import * as React from 'react';

import MoveCopy16 from './MoveCopy16';

export const moveCopy16 = () => <MoveCopy16 />;

export default {
    title: 'Icon|Fill|MoveCopy16',
    component: MoveCopy16,
    parameters: {
        notes: "`import MoveCopy16 from 'box-ui-elements/es/icon/fill/MoveCopy16';`",
    },
};
